import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withModifiers as _withModifiers, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4004e100"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "c-columns"
};
const _hoisted_2 = {
  class: "c-column-list"
};
const _hoisted_3 = ["onMouseenter", "onMouseleave"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_c_title = _resolveComponent("c-title");
  const _component_c_card_txt = _resolveComponent("c-card-txt");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_c_title, _mergeProps({
    title: $props.title
  }, $props.titleProp), null, 16, ["title"]), _createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.list, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "list-item",
      onMouseenter: $event => $options.handleMouseenter(index, item),
      onMouseleave: _withModifiers($event => $options.handleMouseleave(item), ["self"])
    }, [$props.nomouse ? (_openBlock(), _createBlock(_component_c_card_txt, {
      key: 0,
      info: item,
      height: $props.height,
      style: _normalizeStyle({
        background: item.bg ? `url(${item.bg}) center no-repeat ` : ''
      })
    }, null, 8, ["info", "height", "style"])) : (_openBlock(), _createElementBlock(_Fragment, {
      key: 1
    }, [index === $data.currentIndex ? _renderSlot(_ctx.$slots, "mouseenter", {
      key: 0
    }, () => [_createVNode(_component_c_card_txt, {
      info: item.over,
      class: "mouseenter",
      height: $props.height,
      style: _normalizeStyle({
        background: item.over.bg ? `url(${item.over.bg}) center no-repeat ` : ''
      })
    }, null, 8, ["info", "height", "style"])], true) : _renderSlot(_ctx.$slots, "mouseleave", {
      key: 1
    }, () => [_createVNode(_component_c_card_txt, {
      info: item.leave,
      class: "mouseleave",
      height: $props.height,
      style: _normalizeStyle({
        background: item.leave.bg ? `url(${item.leave.bg}) center no-repeat ` : ''
      })
    }, null, 8, ["info", "height", "style"])], true)], 64))], 40, _hoisted_3);
  }), 128))])]);
}